import { render, staticRenderFns } from "./PostagensEscreva.vue?vue&type=template&id=49e8a978&scoped=true"
import script from "./PostagensEscreva.vue?vue&type=script&lang=js"
export * from "./PostagensEscreva.vue?vue&type=script&lang=js"
import style0 from "./PostagensEscreva.vue?vue&type=style&index=0&id=49e8a978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e8a978",
  null
  
)

export default component.exports